import { Navigate, Outlet, useLocation } from "react-router";
import Header from "./Header";
import Footer from "./Footer";
import { Box } from "@mui/material";
import { useResetPasswordContext, useClientPortalConfigContext } from "../../context";
import { usePageTitle } from "hooks/usePageTitle";
import ResetPasswordDialog from "../Account/ResetPassword/ResetPasswordDialog";
import { ROUTES } from "../../routes";

const DIRECT_LINK_ROUTES = [
    ROUTES.PUBLIC_FORM.urlPath,
    ROUTES.INVOICE_PAY.urlPath,
    ROUTES.VIEW_INVOICE.urlPath,
    ROUTES.TELEHEALTH.urlPath,
    ROUTES.TELEHEALTH_PLUS.urlPath,
    ROUTES.REGISTRATION.urlPath,
    ROUTES.LOGIN.urlPath,
    ROUTES.NOT_AVAILABLE.urlPath,
    ROUTES.VIEW_STATEMENT.urlPath,
    ROUTES.FORM_SUBMISSION_SUCCESS.urlPath,
];

function isDirectLinkRoute(pathname: string): boolean {
    const lowerPathname = pathname.toLowerCase();
    return DIRECT_LINK_ROUTES.some((route) => lowerPathname.includes(`/${route.toLowerCase()}`));
}

export default function Layout() {
    const { showResetPasswordDialog } = useResetPasswordContext();
    const { clientPortalConfig } = useClientPortalConfigContext();
    const location = useLocation();
    usePageTitle();

    const isDirectLink = isDirectLinkRoute(location.pathname);
    const shouldRedirectToNotAvailable =
        !isDirectLink &&
        (clientPortalConfig?.isAccountInvalid ||
            clientPortalConfig?.isOffline ||
            clientPortalConfig?.isClientPortalDisabled);

    if (shouldRedirectToNotAvailable) {
        return <Navigate to={ROUTES.NOT_AVAILABLE.urlPath} replace />;
    }

    const showFooter = !clientPortalConfig?.isClientPortalDisabled;

    return (
        <Box data-test-id="section_layout" sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <Header />
            <Outlet />
            {showFooter && <Footer />}
            {showResetPasswordDialog && <ResetPasswordDialog />}
        </Box>
    );
}
